import { render, staticRenderFns } from "./FavoriteProducts.vue?vue&type=template&id=4d2944eb&scoped=true&lang=pug&"
import script from "./FavoriteProducts.vue?vue&type=script&lang=js&"
export * from "./FavoriteProducts.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteProducts.vue?vue&type=style&index=0&id=4d2944eb&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2944eb",
  null
  
)

/* custom blocks */
import block0 from "./FavoriteProducts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports